<template>
    <filter-base
        v-bind="$attrs"
        :filter-config="filters"
    >
        <template slot-scope="filterProps">
            <slot
                :filterConfig="filters"
                :query="filterProps.query"
                :setFilter="filterProps.setFilter"
                :updateFilter="filterProps.updateFilter"
                :values="originalQuery"
            />
        </template>
    </filter-base>
</template>

<script>
    import { mapState } from 'vuex';

    import FilterBase from '../ui/filters/base.vue';
    import filters from './settings/filters';

    export default {
        name: 'RelaxationFilter',
        components: {
            FilterBase,
        },
        data() {
            return {
                filters,
            };
        },
        computed: {
            ...mapState('filters', {
                originalQuery: 'query',
            }),
        },
    };
</script>
